import { motion } from 'framer-motion'
import React from 'react'

/**
 * The `AnimatedImage` function is a React component that renders an image with animation effects.
 */
export default function AnimatedImage({url,alt, className, testid}) {
    return (
        <motion.img 
            title={alt === undefined ? 'icon' : alt}
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 1, scale: 1 }}
            className={className}
            loading="lazy"
            data-testid={testid}
            transition={{
                duration: 0.8,
                delay: 0.5,
                ease: [0, 0.71, 0.2, 1.01],
            }}
            src={url} alt={alt} />
    )
}
